export default __webpack_public_path__ + "assets/img_calculator_boat_expensive-eb47280c.jpg";